var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cus-table-header"},[_c('list-search',{attrs:{"condition":_vm.condition,"collection":_vm.collection},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.collection.list,"loading":_vm.collection.loading,"pagination":{
      total: _vm.collection.total,
      current: _vm.collection.page,
      pageSize: _vm.collection.pageSize,
      showSizeChanger: true,
    },"bordered":"","rowKey":"id"},on:{"change":_vm.listChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }